import { Component, OnInit } from "@angular/core";

import { WebhookCommonComponent } from "../common.components";

@Component({
    selector: 'webhook-form-switch',
    templateUrl: './webhook-form-switch.component.html',
    styleUrl: './webhook-form-switch.component.scss',
    standalone: false
})

export class WebhookFormSwitchComponent extends WebhookCommonComponent implements OnInit {
   
    

}